<template>
  <v-app class="background-transparent">
    <app-header v-if="getFullScreen == 0"/>
    <ModalMessage />
    <v-main>
    <app-bread  v-if="isLogged && getFullScreen == 0" />
    <v-alert v-if="getFeedback" color="red">{{getFeedback}}</v-alert>
      <router-view></router-view>
    </v-main>
    <app-footer v-if="getFullScreen == 0" />
  </v-app>
</template>

<script>
  import Header from './components/header_footer/header.vue'
  import Footer from './components/header_footer/footer.vue'
  import Bread from './components/misc/Bread.vue'
  import ModalMessage from './components/misc/ModalMessage.vue'
  import {mapGetters} from 'vuex'
  import VueCodemirror from 'vue-codemirror'
//  import Jupyter from '@jupyterlab/services'
  import 'codemirror/theme/ayu-dark.css'
  import 'codemirror/theme/shadowfox.css'
  import 'codemirror/theme/neat.css'
  import 'codemirror/theme/solarized.css'

  /* eslint-disable */ 

  export default {
    name: 'App',
    data() {
        return {
            options: {
          theme: 'ayu-dark'
        }
        }
    },
    computed: 
      mapGetters([
        'getFeedback',
        'isLogged',
        'getThemePreference',
        'getFullScreen'
      ])
    , 
    watch: {
        getThemePreference: function() {
          this.themify();
        },
        isLogged: function() {
          this.themify();
        }
    },
    components: {
      'app-header': Header,
      'app-bread': Bread,
      'app-footer': Footer,
      ModalMessage
    },
    methods: {
      themify() {
        var body = document.querySelector('body');
          if(this.isLogged == true) {
              if(this.getThemePreference == 'os-preference') {
                  // ziskame aktualnu preferenciu farebnej schemy
                  const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");

                  // pokial je zvolena OS preferencia - aplikujeme ju
                  if (prefersDarkScheme.matches) {
                    body.setAttribute('data-theme', 'dark');
                    this.setCodeEditorTheme('dark');
                  } else {
                    body.setAttribute('data-theme', 'light');
                    this.setCodeEditorTheme('light');
                  }

                  // pokial je zvolena OS preferencia - kontrolujeme ci pocas behu nebola zmenena téma
                  window.matchMedia('(prefers-color-scheme: dark)')
                  .addEventListener('change', event => {
                    if (event.matches) {
                      body.setAttribute('data-theme', 'dark');
                      this.setCodeEditorTheme('dark');
                    } else {
                      body.setAttribute('data-theme', 'light');
                      this.setCodeEditorTheme('light');
                    }
                  })
              } else if(this.getThemePreference == 'light') {
                    body.setAttribute('data-theme', 'light');
                    this.setCodeEditorTheme('light');
              } else if(this.getThemePreference == 'dark') {
                    body.setAttribute('data-theme', 'dark');
                    this.setCodeEditorTheme('dark');
              } else if(this.getThemePreference == 'colorblind') {
                    body.setAttribute('data-theme', 'colorblind');
                    this.setCodeEditorTheme('colorblind');
              }
        } else {
          body.setAttribute('data-theme', 'light');
        }
      },
      setCodeEditorTheme(currentTheme) {
         if(currentTheme == 'light' || currentTheme == 'colorblind') {
              VueCodemirror.CodeMirror.defaults.theme = 'neat';
         }
         if(currentTheme == 'dark') {
              VueCodemirror.CodeMirror.defaults.theme = 'shadowfox';
         }

         // potrebne osetrit pripad kedy sa zmeni na zaklade OS tema ked je zobrazeny editor
         //... budeme modifikovat classy pridelovane editorom
      }
    },
    created() {
      if (localStorage != null) {
         if (localStorage.getItem('confirm') == null || localStorage.getItem('confirm') != '1')           
            this.$store.dispatch('tryAutologin')
      } 

      Vue.use(VueCodemirror)
//      Vue.use(Jupyter)

      this.themify();
    }
  }

</script>

<style>
</style>